import moment from 'moment'
import config from '../api/constants'
import http from '../api/api'

const getAllBeneficiaries = async () => {
  try {
    const reqParams = {
      requestId: 'BENE_LIST',
      module: 'Beneficary',
    }
    const response = await http.post(config.apiRoute.GET_ALL_BENEFICIARIES, reqParams)
    const beneficiaries = response.data
    const beneficiaryList = [
      ...beneficiaries.internalBeneficiaries,
      ...beneficiaries.thirdPartyBeneficiaries,
    ]
    const accountList = beneficiaryList.map((v) => v.beneAccNo)
    const params = {
      accountNo: accountList,
      requestId: 'BENE_IMGLIST',
      module: 'Beneficary',
    }
    const imagesResponse = await http.post(config.apiRoute.GET_BENEFICIARY_IMAGES, params)
    const images = imagesResponse.data.imagesList
    beneficiaries.internalBeneficiaries.forEach((ben) => {
      const image = images.find((v) => ben.beneAccNo === v.acctNo)
      ben.image = image === undefined ? null : `data:image/png;base64,${image.imageData}`
    })
    beneficiaries.thirdPartyBeneficiaries.forEach((ben) => {
      const image = images.find((v) => ben.beneAccNo === v.acctNo)
      ben.image = image === undefined ? null : `data:image/png;base64,${image.imageData}`
    })
    return { status: response.status, data: beneficiaries }
  } catch (err) {
    throw err.response.data
  }
}

const getAllBanks = async () => {
  try {
    const reqParams = {
      requestId: 'OTHERBANKSLIST',
    }
    const response = await http.post(config.apiRoute.GET_ALL_BANKS, reqParams)
    return response.data //.bankList
  } catch (err) {
    throw err.response.data
  }
}

const getCountries = async () => {
  try {
    const reqParams = {
      requestId: 'BENE_ADDINTBEN',
      module: 'Beneficary',
    }
    const response = await http.post(config.apiRoute.GET_ALL_COUNTRIES, reqParams)
    return response.data.country
  } catch (err) {
    throw err.response.data
  }
}

const getInternationalBanks = async (country) => {
  try {
    const reqParams = {
      requestId: 'GETSWIFTCODES',
      country,
    }
    const response = await http.post(config.apiRoute.GET_ALL_INTERNATIONAL_BANKS, reqParams)
    return response.data.bankList
  } catch (err) {
    throw err.response.data
  }
}

const verifyFundTransfer = async (reqParams) => {
  try {
    const params = {
      module: 'FUNDTRANSFER',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.VERIFY_TRANSFER, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const confirmFundTransfer = async (reqParams) => {
  try {
    const params = {
      module: 'FUNDTRANSFER',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.CONFIRM_TRANSFER, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyAddBeneficiary = async (reqParams) => {
  try {
    const params = {
      requestId: 'BENE_VERIFY',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.VERIFY_ADD_INTERNAL_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const getFTTerms = async (transferType) => {
  try {
    const reqParams = {
      requestId: 'TERMS',
      module: transferType === 'IAT' ? 'INBK' : transferType,
    }
    const response = await http.post(config.apiRoute.GET_TERMS_AND_CONDITIONS, reqParams)
    return response.data.termsCondition[0]
  } catch (err) {
    throw err.response.data
  }
}

const confirmAddBeneficiary = async (reqParams) => {
  try {
    const params = {
      requestId: 'BENE_VERIFY',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.CONFIRM_ADD_INTERNAL_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const addOtherBeneficiary = async (reqParams) => {
  try {
    const params = {
      requestId: 'ADDOTHRBENE',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.ADD_THIRD_PARTY_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyAddOtherBeneficiary = async (reqParams) => {
  try {
    const params = {
      requestId: 'BENE_OTHVERIFY',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.VERIFY_ADD_THIRD_PARTY_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyEditInternalBeneficiary = async (reqParams) => {
  try {
    const params = {
      requestId: 'BENE_MODIFY',
      module: 'Beneficary',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.VERIFY_EDIT_INTERNAL_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const editInternalBeneficiary = async (reqParams) => {
  try {
    const params = {
      requestId: 'BENE_MODIFY',
      module: 'Beneficary',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.CONFIRM_EDIT_INTERNAL_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyEditOtherBeneficiary = async (reqParams) => {
  try {
    const params = {
      requestId: 'BENE_MODIFY',
      module: 'Beneficary',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.VERIFY_EDIT_THIRDPARTY_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const editOtherBeneficiary = async (reqParams) => {
  try {
    const params = {
      requestId: 'BENE_MODIFY',
      module: 'Beneficary',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.CONFIRM_EDIT_THIRDPARTY_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const removeBeneficiaryVerify = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'BENE_REMOVE',
      module: 'Beneficary',
    }
    const response = await http.post(config.apiRoute.VERIFY_REMOVE_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const removeBeneficiary = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'BENE_REMOVE',
      module: 'Beneficary',
    }
    const response = await http.post(config.apiRoute.REMOVE_BENEFICIARY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const changeBeneficiaryImage = async (reqParams) => {
  try {
    const params = {
      requestId: 'BENE_SETIMG',
      module: 'Beneficary',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.CHANGE_BENEFICIARY_IMAGE, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.dta
  }
}

const deleteBeneficiaryImage = async ({ accountNo }) => {
  try {
    const reqParams = {
      accountNo: accountNo,
      requestId: 'BENE_REMOVEIMG',
      module: 'Beneficary',
    }
    const response = await http.post(config.apiRoute.DELETE_BENEFICIARY_IMAGE, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getBeneficiaryImages = async ({ accountNumber }) => {
  try {
    const reqParams = {
      accountNo: accountNumber,
      requestId: 'BENE_IMGLIST',
      module: 'Beneficary',
    }
    const response = await http.post(config.apiRoute.GET_BENEFICIARY_IMAGES, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getReceipt = async () => {
  try {
    const reqParams = {
      requestId: 'RECEIPTTXN',
      transRefNum: '',
      refId: 0,
    }
    const response = await http.post(config.apiRoute.LAST_N_TRANSACTIONS, reqParams)

    if (response.data.userReceiptRecord !== null) {
      const lastTransaction = response.data.userReceiptRecord[0]
      const downloadFile = await http.post(
        config.apiRoute.DOWNLOAD_RECEIPT,
        {
          refId: lastTransaction.receiptId,
          requestId: 'RECEIPTDOWNLOAD',
          transRefNum: lastTransaction.transRefId,
        },
        { responseType: 'arraybuffer' },
      )
      showFile(downloadFile.data, lastTransaction.transRefId)
      return downloadFile.data
    }
    return ''
  } catch (err) {
    throw err.response.data
  }
}

export function showFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: 'application/pdf' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.pdf`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

export function showCSVFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/csv' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.csv`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}


export function showXlsxFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: 'application/xlsx' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.xlsx`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

const lastNTransaction = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'RECEIPTDOWNLOAD',
    }
    const response = await http.post(config.apiRoute.LAST_N_TRANSACTIONS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const recieptTransfer = async () => {
  try {
    const reqParams = {
      module: 'TRANSFERS', //empty for all types, PAYMENTS, TRANSFERS
      requestId: 'RECEIPTTXN',
      transRefNum: '',
      refId: 0,
    }
    const response = await http.post(config.apiRoute.RECIEPT_TRANSFER, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const recieptPayment = async () => {
  try {
    const reqParams = {
      module: 'PAYMENTS', //empty for all types, PAYMENTS, TRANSFERS
      requestId: 'RECEIPTTXN',
      transRefNum: '',
      refId: 0,
    }
    const response = await http.post(config.apiRoute.RECIEPT_TRANSFER, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const downLoadReport = async (reqParams) => {
  try {
    const params = {
      requestId: 'RECEIPTDOWNLOAD',
      ...reqParams
    }
    const downloadFile = await http.post(
      config.apiRoute.DOWNLOAD_RECEIPT, params,
      { responseType: 'arraybuffer' },
    )
    showFile(downloadFile.data, reqParams.transRefNum)
    return downloadFile.data
  } catch (err) {
    throw err.response.data
  }
}


const downLoadBillPayReport = async (reqParams) => {
  try {
    const params = {
      refId: reqParams.receiptId,
      requestId: 'RECEIPTDOWNLOAD',
      transRefNum: '',
      module:"BILLPAYMENT"
    }
    const downloadFile = await http.post(
      config.apiRoute.DOWNLOAD_PAYMENT_RECEIPT, params,
      { responseType: 'arraybuffer' },
    )
    showFile(downloadFile.data, reqParams.receiptId)
    return downloadFile.data
  } catch (err) {
    throw err.response.data
  }
}

const downLoadMT103Report = async (reqParams) => {
  try {
    const params = {
      contractRefNo: reqParams.contractRefNo,
      requestId: 'MT103MESSAGE',
      sourceAccount: reqParams.accountNumber,
      module: 'MT103',
    }
    const downloadFile = await http.post(config.apiRoute.DOWNLOAD_MT103_RECEIPT, params, {
      responseType: 'arraybuffer',
    })
    showFile(downloadFile.data, reqParams.contractRefNo)
    return downloadFile.data
  } catch (err) {
    throw err.response.data
  }
}

const downLoadBiStatement = async (data) => {
  try {
    const reqParams = {
      reportName: data.reportName,
      requestId: 'BISTATEMENT',
      srcAccount: data.accountNumber,
      format: data.format,
      fromDate: moment(data.fromDate).format('DD-MM-YYYY'),
      toDate: moment(data.toDate).format('DD-MM-YYYY'),
      module: 'Bi',
    }
    const downloadFile = await http.post(config.apiRoute.DOWNLOAD_BI_STATEMENT, reqParams, {
      responseType: 'arraybuffer',
    })
    if (data.format === 'pdf') {
      showFile(downloadFile.data, data.reportName)
    } else {
      showXlsxFile(downloadFile.data, data.reportName)
    }
    return downloadFile.data
  } catch (err) {
    throw err?.response?.data
  }
}

const getCurrencyList = async (reqParams) => {
  try {
    const params = {
      requestId: 'CURRENCYLIST',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.CURRENCY_LIST, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getCharges = async (reqParams) => {
  try {
    const params = {
      requestId: 'FTCHARGE',
      ...reqParams,
    }
    const response = await http.post(config.apiRoute.CHARGE_FT, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const transactionListForRepay = async () => {
  try {
    const reqParams = {
      requestId: "RECEIPTTXN",
      module: "FUNDTRANSFER",
    }
    const response = await http.post(config.apiRoute.LAST_N_TRANSACTIONS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const viewScheduledTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'VIEW_SCHEDULED_TRANSFERS',
      module: 'SCHEDULEDPAYMENTS',
    }
    const response = await http.post(config.apiRoute.VIEW_SCHEDULED_TRANSFER, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const verifyCancelScheduledTransfer = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'CANCEL_SCHEDULED_TRANSFERS',
      module: 'SCHEDULEDPAYMENTS',
    }
    const response = await http.post(config.apiRoute.VERIFY_SCHDULED_TRANSFER, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const confirmCancelScheduledTransfer = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'CANCEL_SCHEDULED_TRANSFERS',
      module: 'SCHEDULEDPAYMENTS',
    }
    const response = await http.post(config.apiRoute.CONFIRM_SCHEDULED_TRANSFER, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const BeneficiaryTransferService = {
  getAllBeneficiaries,
  getAllBanks,
  getCountries,
  getInternationalBanks,
  verifyFundTransfer,
  confirmFundTransfer,
  verifyAddBeneficiary,
  getFTTerms,
  confirmAddBeneficiary,
  addOtherBeneficiary,
  verifyAddOtherBeneficiary,
  verifyEditInternalBeneficiary,
  editInternalBeneficiary,
  verifyEditOtherBeneficiary,
  editOtherBeneficiary,
  removeBeneficiaryVerify,
  removeBeneficiary,
  changeBeneficiaryImage,
  deleteBeneficiaryImage,
  getBeneficiaryImages,
  getReceipt,
  lastNTransaction,
  recieptTransfer,
  recieptPayment,
  downLoadReport,
  downLoadMT103Report,
  downLoadBiStatement,
  getCurrencyList,
  getCharges,
  transactionListForRepay,
  viewScheduledTransfer,
  verifyCancelScheduledTransfer,
  confirmCancelScheduledTransfer,
  downLoadBillPayReport
}

export default BeneficiaryTransferService
